{
  "about": {
    "paragraph": "Nous nous engageons pour répondre aux enjeux de la loi AGEC et informer nos clients sur l’origine et les qualités environnementales de nos produits.",
    "title": "À propos"
  },
  "detailedProductComposition": {
    "title": "Composition"
  },
  "lastUpdate": "Date de mise à jour : ",
  "loading": {
    "dataPending": "collecte actuellement ces Informations",
    "pendingLocation": "Localisation en cours"
  },
  "activities": {
    "APPAREL_MANUFACTURING": "Confection",
    "FOOTWEAR_FINISHING": "Finition",
    "FOOTWEAR_STITCHING": "Piquage",
    "FOOTWEAR_ASSEMBLING": "Assemblage",
    "FABRIC_WEAVING_OR_KNITTING": "Tissage / Tricotage",
    "FABRIC_DYEING_PRINTING": "Teinture",
    "YARN_PROVIDER": "Matière première",
    "YARN_DYEING_PRINTING": "Teinture",
    "LEATHER_TANNING": "Tannage",
    "LEATHER_DYEING_PRINTING": "Teinture",
    "ACCESSORY_PROVIDER": "Fournisseur d'accessoire",
    "YARN_MATERIAL_PRODUCTION": "Matière première",
    "FABRIC_SPINNING": "Filature",
    "FABRIC_MATERIAL_PRODUCTION": "Matière première",
    "LEATHER_MATERIAL_PRODUCTION": "Abattoir",
    "ACCESSORY_RAW_MATERIAL_PROVIDER": "Matière première",
    "COATING": "Enduction"
  },
  "other": {
    "microplastics_bold": "libère des microplastiques",
    "paragraph1": "Ce produit comporte ",
    "paragraph1_100": "Ce produit comporte 100% de matières recyclées.",
    "paragraph2_1": "Ce produit ",
    "paragraph2_2": "  dans l'environnement lors du lavage : en masse ",
    "paragraph2_3": "du produit est constitué de fibres synthétiques.",
    "paragraph3": "Informations sur la présence potentielle de substances dangereuses sur l'application : ",
    "recycled_matertials_bold": "au moins {{percent}}% de matières recyclées.",
    "recycled_matertials_bold_50": "plus de 50% ",
    "title": "Autres qualités et caractéristiques environnementales"
  },
  "packaging": {
    "recyclable": "Recyclabilité: Emballage recyclable.",
    "recycled": "Incorporation de matière recyclée: Emballage comportant au moins {{percent}}% de matières recyclées.",
    "recycled_100": "Incorporation de matière recyclée: Emballage comportant 100% de matières recyclées.",
    "title": "Qualités et caractéristiques environnementales de l'emballage"
  },
  "title": "Qualités et caractéristiques environnementales du produit",
  "traceability": {
    "paragraph": "Il s'agit de l'origine de votre produit sur ses trois premières étapes de production, depuis sa confection jusqu’au tissage et à la teinture de sa matière principale.",
    "title": "Traçabilité du produit"
  },
  "ecoScore": {
    "title": "EcoScore",
    "b2b": "Coût environnemental : {{cost}} points d'impact"
  }
}
